import styled, { css } from "styled-components";

import { FlexRow } from "@similarweb/ui-components";

export const StyledFilterWrapper = styled(FlexRow)<{ isDisabled?: boolean }>`
    justify-content: center;

    & .filterChip {
        margin: 0;
    }

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            opacity: 0.3;

            & .hideActionButton {
                cursor: not-allowed;
                pointer-events: none;
            }
        `}

    .CustomStyledFilter {
        margin: 0;
    }
`;
